<template>
  <CRow>
    <Modal :modal="modal"></Modal>

    <CCol lg="12">
      <div class="d-flex align-items-center justify-content-end mb-3">
        <a
          href="javascript:void(0)"
          @click="$router.go(-1)"
        >
          <CIcon
            name="cil-arrow-left"
            class="mr-2"
          />Voltar
        </a>
      </div>

      <CForm @submit.prevent="send">
        <!-- Title -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Notí­cia' : 'Cadastrar Notí­cia' }}
            </h4>

            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center">
                <!-- Highlight -->
                <label class="mb-0">
                  <b>Destaque</b>
                </label>

                <CSwitch
                  type="checkbox"
                  color="warning"
                  variant="3d"
                  class="mx-2 mr-md-4"
                  v-bind="labelIcon"
                  :checked.sync="form.favorite"
                />

                <!-- Status -->
                <label class="mb-0">
                  <b>Status</b>
                </label>
                <CSwitch
                  type="checkbox"
                  color="success"
                  variant="3d"
                  class="mx-2"
                  v-bind="labelIcon"
                  :checked.sync="form.status"
                />
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <CCol lg="4">
                    <label for="focus-of-action">Data da publicação*</label>
                    <div class="form-group">
                      <Datepicker
                        :value="form.publication_at"
                        class="no-margin-bottom"
                        :disabled="processing"
                        @selected="
                          (publication_at) =>
                            (form.publication_at = form.publication_at =
                              publication_at)
                        "
                      />
                    </div>
                  </CCol>

                  <CCol
                    lg="4"
                  >
                    <div class="form-group">
                      <label for="category_id">Categoria*</label>
                      <Multiselect
                        :value="categoriesOptions.find(option => option.value == form.category_id)"
                        :options="categoriesOptions"
                        label="label"
                        track-by="value"
                        placeholder="Categoria"
                        :disabled="processing"
                        @select="(selected) => form.category_id = selected.value"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>

                  <CCol lg="4">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      placeholder="Título"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>
                      <TextEditor
                        id="description"
                        v-model="form.text"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related Products -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos Relacionados
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos</label>

                      <Multiselect
                        id="relatedProducts"
                        :value="relatedProductsOptions.filter((option) => form.products.includes(option.value))"
                        :options="relatedProductsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="2"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.products.push(selected.value)"
                        @remove=" (removed) => form.products.splice(form.products.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- Images -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Imagens
                  </h5>
                </div>

                <div class="form-group">
                  <FileUploader
                    id="main_image"
                    :max-files="1"
                    :uploader-info="mainImageConfig.uploaderInfo"
                    :extensions="mainImageConfig.extensions"
                    :accept-types="mainImageConfig.acceptTypes"
                    :enable-multiple="false"
                    :medias="form.main_image"
                    :min-cropped-width="771"
                    :min-cropped-height="428"
                    :enable-edit-on-api-table="false"
                  />
                </div>

                <div class="form-group">
                  <FileUploader
                    id="medias"
                    :max-files="25"
                    :uploader-info="mediasConfig.uploaderInfo"
                    :extensions="mediasConfig.extensions"
                    :accept-types="mediasConfig.acceptTypes"
                    :enable-multiple="true"
                    :medias="form.medias"
                    :min-cropped-width="771"
                    :min-cropped-height="428"
                  />
                </div>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="news"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo"
                  :page-title="form.title"
                  :page-description="form.text"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.text_en"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="news"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.text_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.text_es"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="news"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.text_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <div class="d-flex justify-content-end align-items-center mt-4 mb-4">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
import CardLog from '@/components/ui/CardLog'
import Datepicker from '@/components/ui/Datepicker'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import TextEditor from '@/components/ui/TextEditor'
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import Seo from '@/components/ui/Seo'
import Multiselect from '@/components/ui/Multiselect'
import TabsStatus from '@/components/ui/TabsStatus'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import Service from '@/services/news.service'
import CategoryService from '@/services/news-category.service'
import ProductService from '@/services/products.service'

export default {
  metaInfo: {
    title: 'Notí­cias',
    titleTemplate: ' %s - Manager - Intelli'
  },

  components: {
    CardLog,
    TextEditor,
    Datepicker,
    FileUploader,
    Seo,
    Modal,
    Multiselect,
    TabsStatus,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        category_id: '',
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        text: '',
        text_en: '',
        text_es: '',
        publication_at: '',
        favorite: false,
        status: true,
        status_en: false,
        status_es: false,
        products: [],
        main_image: [],
        medias: [],
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      form: {
        products: []
      },
      mainImageConfig: {
        uploaderInfo: {
          label: 'Imagem principal*'
        },
        extensions: 'jpg,jpeg,png',
        acceptTypes: 'image/png,image/jpeg'
      },
      mediasConfig: {
        uploaderInfo: {
          label: 'Galeria de imagens'
        },
        extensions: 'jpg,jpeg,png',
        acceptTypes: 'image/png,image/jpeg'
      },
      statusIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      favoriteIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      log: {},
      isLoading: true,
      processing: false,
      redirect: true,
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      categoriesOptions: [],
      relatedProductsOptions: [],
      activeTabIndex: 0
    }
  },

  async created() {
    await this.getCategoriesOptions()
    await this.getProductsOptions()
    await this.setItens()
  },

  methods: {
    async getCategoriesOptions() {
      const response = await CategoryService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.categoriesOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    },

    async getProductsOptions() {
      const response = await ProductService.newsProducts({ pagination: false, sorter: { column: 'title', asc: true } })

      this.relatedProductsOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    },

    async setItens() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            category_id: data.category_id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            text: data.text,
            text_en: data.text_en,
            text_es: data.text_es,
            publication_at: data.publication_at,
            favorite: data.favorite,
            products: data.products.map(product => product.id),
            main_image: data.main_image,
            medias: data.medias,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      } else {
        this.item.publication_at = moment().format('YYYY-MM-DD')
      }
      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItens()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        category_id: this.form.category_id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        text: this.form.text,
        text_en: this.form.text_en,
        text_es: this.form.text_es,
        publication_at: this.form.publication_at,
        favorite: this.form.favorite,
        products: this.form.products,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null,
        medias: this.form.medias.map((media) => media.id)
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Notícia foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Notícia foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
